export default __webpack_public_path__ + "static/Corprate_WhoWeAre_SLT_07-d2e502c629caf9e9ca262431febcaeb3.jpg";